<template>
<div class="chapter">
<div class="inner_page">
<p class="title"><span class="green1">COMFORT CROCHETED</span></p>
<p class="title1"><span class="litgreen">AFGHANS</span></p>
<p class="center"><span class="orange3">A<span class="smallcaps">N</span> H<span class="smallcaps">EIRLOOM</span> T<span class="smallcaps">RIO FOR A</span> C<span class="smallcaps">OZY</span> H<span class="smallcaps">OME AND</span> F<span class="smallcaps">AMILY</span></span></p>
<p class="centert1a"><span class="orange3">Norah Gaughan, Margery Winter, and the Berroco Design Team</span></p>
<p class="centert"><span class="orange3">Photographs by Thayer Allyson Gowdy<br/>Styling by Karen Schaupeter</span></p>
<p class="centert1s"><span class="ash">STC CRAFT / A MELANIE FALICK BOOK<br/>STEWART, TABORI &amp; CHANGE<br/>NEW YORK</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2_Title.vue?4731f561